import "./Philosophy.module.css";
import Header from "@/reusable_sections/Header";
import TheStoryBehindTheSpace from "./sections/TheStoryBehindTheSpace";
import OurCoreValues from "./sections/OurCoreValues";
import SiteFooter from "@/reusable_sections/Footer";
export default function PhilosophyPage() {
  return <div>
      <Header />
      <TheStoryBehindTheSpace />
      <OurCoreValues />
      <SiteFooter />
    </div>;
}